/**
 * /favoris — refonte « bonnes affaires » du 2026-09-14.
 *
 * Les favoris s'affichent avec la carte de la vitrine (prix, cote barrée,
 * écart) : une annonce sauvegardée se relit comme une affaire, pas comme une
 * fiche au « score IA ». Liste vide : les bonnes affaires du moment.
 */
import React, { useEffect, useState } from 'react';
import Page from '../components/Layout/Page';
import AffaireCard from '../components/Affaires/AffaireCard';
import BandeauAffaires from '../components/Affaires/BandeauAffaires';
import { carteDepuisAnnonce } from '../components/Affaires/format';
import api from '../services/api';
import '../components/Affaires/Affaires.css';
import './ComptePages.css';

function Favori({ favori, onRetire }) {
  const [retrait, setRetrait] = useState(false);
  async function retirer() {
    setRetrait(true);
    try {
      await api.delete(`/api/favorites/${favori.listing.id}`);
      onRetire(favori.listing.id);
    } catch {
      setRetrait(false);
    }
  }
  return (
    <div className="zk-cpt-item">
      <AffaireCard a={carteDepuisAnnonce(favori.listing)} />
      <div className="zk-cpt-action">
        <span>Sauvegardée le {new Date(favori.saved_at).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' })}</span>
        <button type="button" onClick={retirer} disabled={retrait}>{retrait ? 'Retrait…' : 'Retirer'}</button>
      </div>
    </div>
  );
}

export default function FavoritesPage() {
  const [favoris, setFavoris] = useState([]);
  const [chargement, setChargement] = useState(true);

  useEffect(() => {
    api.get('/api/favorites/')
      .then((r) => setFavoris(r.data || []))
      .catch(() => {})
      .finally(() => setChargement(false));
  }, []);

  const n = favoris.length;

  return (
    <Page
      titre="Mes favoris"
      chapeau={chargement ? 'Chargement…' : `${n} annonce${n > 1 ? 's' : ''} sauvegardée${n > 1 ? 's' : ''}.`}
    >
      {!chargement && n === 0 && (
        <div className="zk-carte zk-cpt-vide">
          <h2>Aucun favori pour l’instant</h2>
          <p>Touchez le cœur d’une annonce pour la retrouver ici.</p>
        </div>
      )}

      {n > 0 && (
        <div className="zk-cpt-grille">
          {favoris.map((f) => (
            <Favori key={f.favorite_id} favori={f} onRetire={(id) => setFavoris((p) => p.filter((x) => x.listing.id !== id))} />
          ))}
        </div>
      )}

      {!chargement && <BandeauAffaires />}
    </Page>
  );
}
